<template>
  <ul class="prayer-times" :class="{ dark: theme === 'dark' }">
    <li
      v-for="prayerTime in prayerTimes"
      :key="prayerTime.icon"
      class="prayer-times__item"
      :class="{
        active: activePrayerTime && prayerTime.icon === activePrayerTime.icon,
      }"
    >
      <svg-icon :name="prayerTime.icon" class="prayer-times__icon" />
      <div class="flex flex-col">
        <span class="prayer-times__title">{{ prayerTime.title }}</span>
        <span class="prayer-times__time">{{ prayerTime.time }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
import { defineComponent } from "vue";
import SvgIcon from "@/components/SvgIcon.vue";
import i18n from "@/locales";

let t = i18n.global.t;

export default defineComponent({
  components: { SvgIcon },
  props: {
    theme: {
      type: String,
      default: "light", // light, dark
    },
  },
  // times: [
  //   {
  //     icon: "fajr",
  //     title: t("prayerTimes.fajr"),
  //   },
  //   {
  //     icon: "sunrise",
  //     title: t("prayerTimes.sunrise"),
  //   },
  //   {
  //     icon: "dhuhr",
  //     title: t("prayerTimes.dhuhr"),
  //   },
  //   {
  //     icon: "asr",
  //     title: t("prayerTimes.asr"),
  //   },
  //   {
  //     icon: "maghrib",
  //     title: t("prayerTimes.maghrib"),
  //   },
  //   {
  //     icon: "isha",
  //     title: t("prayerTimes.isha"),
  //   },
  // ],
  computed: {
    times() {
      return [
        {
          icon: "fajr",
          title: t("prayerTimes.fajr"),
        },
        {
          icon: "sunrise",
          title: t("prayerTimes.sunrise"),
        },
        {
          icon: "dhuhr",
          title: t("prayerTimes.dhuhr"),
        },
        {
          icon: "asr",
          title: t("prayerTimes.asr"),
        },
        {
          icon: "maghrib",
          title: t("prayerTimes.maghrib"),
        },
        {
          icon: "isha",
          title: t("prayerTimes.isha"),
        },
      ];
    },
    prayerTimes() {
      const pt = this.$store.state.prayerTimes;
      if (!pt) return null;
      return this.times.map((time) => {
        return {
          ...time,
          time: pt[time.icon],
        };
      });
    },

    activePrayerTime() {
      if (!this.prayerTimes) return null;

      const now = new Date();
      const currentTime = now.getHours() * 60 + now.getMinutes();

      const prayerTimes = this.prayerTimes;
      if (!prayerTimes) return null;

      // Преобразуем время намазов в минуты
      const timesInMinutes = prayerTimes.map((prayer) => {
        const [hours, minutes] = prayer.time.split(":").map(Number);
        return {
          ...prayer,
          timeInMinutes: hours * 60 + minutes,
        };
      });

      // Находим текущий намаз
      for (let i = 0; i < timesInMinutes.length; i++) {
        const currentPrayer = timesInMinutes[i];
        const nextPrayer = timesInMinutes[i + 1];

        if (nextPrayer) {
          if (
            currentTime >= currentPrayer.timeInMinutes &&
            currentTime < nextPrayer.timeInMinutes
          ) {
            return currentPrayer;
          }
        } else {
          // Для последнего намаза (Иша) проверяем до следующего дня
          if (currentTime >= currentPrayer.timeInMinutes) {
            return currentPrayer;
          }
        }
      }

      // Если текущее время меньше времени первого намаза (Фаджр),
      // значит текущий намаз - это последний намаз предыдущего дня (Иша)
      return timesInMinutes[timesInMinutes.length - 1];
    },
  },
});
</script>

<style scoped lang="scss">
.prayer-times {
  @apply flex items-center w-full justify-between gap-3;
  .prayer-times__item {
    @apply flex items-center gap-2;

    .prayer-times__icon {
      @apply hidden lg:block w-[30px] h-[30px] xl:w-[36px] xl:h-[36px];
    }
    .prayer-times__title {
      @apply text-[10px] text-[#444444] leading-[140%];
    }
    .prayer-times__time {
      font-weight: 500;
      @apply text-[14px] text-[#222222] leading-[140%] lg:text-[12px] xl:text-[14px];
    }

    &.active {
      .prayer-times__icon {
        @apply text-yellow-400;
      }
      .prayer-times__time {
        @apply opacity-100 text-[#058242];
      }
    }
  }

  &.dark {
    .prayer-times__item {
      .prayer-times__icon {
        @apply text-zinc-400;
      }
      .prayer-times__title {
        @apply text-white opacity-60;
      }
      .prayer-times__time {
        @apply text-white opacity-60;
      }

      &.active {
        .prayer-times__time {
          @apply opacity-100;
        }
        .prayer-times__icon {
          @apply text-yellow-400;
        }
      }
    }
  }
}
</style>
